import React from "react";
import { connect } from "react-redux";
import { Button, Paper } from "@material-ui/core";
import { GetApp } from "@material-ui/icons";
import { CSVLink } from "react-csv";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  title: { display: "flex", justifyContent: "flex-end", padding: 16 },
  wrapper: { display: "flex", minHeight: 200 },
  labels: { flex: "0 0 250px" },
  data: { overflowX: "auto", marginTop: 4 },
  table: { borderCollapse: "separate", borderSpacing: 0 },
  labelCell: { height: 45, minWidth: 250, paddingLeft: 16, fontSize: 13, borderBottom: "1px solid #eee6e6", borderRight: "1px solid #eee6e6" },
  headerCell: { height: 40, minWidth: 80, paddingRight: 10, textAlign: "right", fontSize: 11, color: "#666", borderTop: "1px solid #eee6e6", borderBottom: "1px solid #eee6e6", borderRight: "1px solid #eee6e6" },
  valueCell: { height: 45, minWidth: 80, paddingRight: 10, textAlign: "right", fontSize: 13, borderBottom: "1px solid #eee6e6", borderRight: "1px solid #eee6e6" },
});

const PicTreeTablePhotoSubTypeCommon = ({ photoShootTrend }) => {
  const classes = useStyles();
  const trend = photoShootTrend?.[0] || {};
  const dates = trend.date || [];
  const keys = Object.keys(trend).filter((key) => key !== "date");
  const csv = [
    ["アセットタイプ別レビューOKデータ", ...dates],
    ...keys.map((key) => [key, ...trend[key]]),
  ];

  return (
    <Paper>
      <div className={classes.title}>
        <CSVLink data={csv} filename="PicTree - アセットタイプ別レビューOKトレンドデータ">
          <Button variant="contained" startIcon={<GetApp />}>CSV出力</Button>
        </CSVLink>
      </div>
      {keys.length > 0 && (
        <div className={classes.wrapper}>
          <div className={classes.labels}>
            <table className={classes.table}><tbody>
              <tr><td className={classes.labelCell}></td></tr>
              {keys.map((key) => <tr key={key}><td className={classes.labelCell}>{key}</td></tr>)}
            </tbody></table>
          </div>
          <div className={classes.data}>
            <table className={classes.table}><tbody>
              <tr>{dates.map((date) => <td className={classes.headerCell} key={date}>{date}</td>)}</tr>
              {keys.map((key) => (
                <tr key={key}>{trend[key].map((value, index) => <td className={classes.valueCell} key={`${key}:${index}`}>{value}</td>)}</tr>
              ))}
            </tbody></table>
          </div>
        </div>
      )}
    </Paper>
  );
};

export default connect()(PicTreeTablePhotoSubTypeCommon);
